import { ModalWrapper } from '../components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';
import { ReferralLink } from 'src/pages/AccountProfile/Main/components/ReferralBlcok/ReferralLink';
import { ReferralTitle } from 'src/pages/AccountProfile/Main/components/ReferralBlcok/ReferralTitle';
import { useTranslation } from 'react-i18next';
import { config } from './config';

interface ReferralModalProps {
  onCopyClick: () => void;
  referralLink: string;
}

export const ReferralModal = () => {
  const { t } = useTranslation();
  const { modalProps } = useModalContext<ReferralModalProps>();

  return (
    <ModalWrapper
      className="640:!max-w-[500px] !max-w-full w-full items-start gap-4"
      containerClassName="!bg-primary_300 !rounded-b-none 640:!rounded-b-[20px] flex flex-col items-center rounded-2xl mt-auto 640:mt-0 pt-5 px-6 pb-7 640:border-solid border-[1px] border-none ">
      <ReferralTitle onClick={modalProps.onCopyClick} isModal />
      <div className="flex flex-col gap-2.5">
        <p className="text-text_tertiary text-sm font-medium">{t('referral.howItWorks')}</p>

        {config.map(({ Icon, id, text }) => (
          <div className="flex gap-2 items-center" key={id}>
            <div className="w-9 h-9 flex flex-col items-center justify-center rounded-full bg-surface_theme_secondary">
              <Icon />
            </div>
            <p className="text-text_primary font-medium">{t(text)}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-1 w-full">
        <h4 className="text-text_tertiary text-sm font-medium">{t('referral.yourLink')}</h4>
        <ReferralLink
          referralLink={modalProps.referralLink}
          onCopyClick={modalProps.onCopyClick}
          isModal
        />
      </div>
    </ModalWrapper>
  );
};
